import { render, staticRenderFns } from "./navs.vue?vue&type=template&id=36a698ca&scoped=true"
import script from "./navs.vue?vue&type=script&lang=js"
export * from "./navs.vue?vue&type=script&lang=js"
import style0 from "./navs.vue?vue&type=style&index=0&id=36a698ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a698ca",
  null
  
)

export default component.exports